import React, { MouseEvent, RefObject } from 'react'

import { IoPlaySkipBack, IoPlaySkipForward } from 'react-icons/io5'
import {
  MdOutlinePauseCircleFilled,
  MdOutlinePlayCircleFilled,
} from 'react-icons/md'

import { Spacer } from '../global'

import {
  MusicPlayerButtons,
  MusicPlayerDisc,
  PlayerButtons,
  TimerSection,
  MusicProgression,
} from './styles'

interface MPButtonsProps {
  isPlaying: boolean
  handlePrev: () => void
  handleNext: () => void
  handlePlayPause: () => void
  formatTime: (time: number) => string
  currentTime: number
  duration: number
  progressRef: RefObject<HTMLDivElement>
  handleProgressClick: (e: MouseEvent<HTMLDivElement>) => void
}

const MPButtons = ({
  isPlaying,
  handlePrev,
  handleNext,
  handlePlayPause,
  formatTime,
  currentTime,
  duration,
  progressRef,
  handleProgressClick,
}: MPButtonsProps) => {
  return (
    <MusicPlayerButtons>
      <MusicPlayerDisc
        style={{
          width: '130px',
          height: '130px',
          top: '-35px',
          // left: '-54px',
        }}
      >
        <div className="disc-base"></div>
        <div
          className="disco"
          style={{
            animation: isPlaying ? 'girar 5s linear infinite' : '',
          }}
        ></div>
      </MusicPlayerDisc>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: 'calc(100% - 130px)',
        }}
      >
        <PlayerButtons
          style={{
            marginTop: 0,
            height: '50px',
            display: 'grid',
            gridTemplateColumns: '20px 50px 20px ',
          }}
        >
          {/* <TimerSection
                  style={{
                    fontSize: 12,
                    justifySelf: 'flex-start',
                    alignSelf: 'flex-end',
                  }}
                >
                  <span>{formatTime(currentTime)}</span>

                  <span>{formatTime(duration)}</span>
                </TimerSection> */}
          <button className="prev" onClick={handlePrev}>
            <IoPlaySkipBack />
          </button>
          <button className="play" onClick={handlePlayPause}>
            <div></div>
            {isPlaying ? (
              <MdOutlinePauseCircleFilled />
            ) : (
              <MdOutlinePlayCircleFilled />
            )}
          </button>

          <button className="next" onClick={handleNext}>
            <IoPlaySkipForward />
          </button>
          {/* <TimerSection
                  style={{
                    fontSize: 12,
                    justifySelf: 'flex-start',
                    alignSelf: 'flex-end',
                  }}
                >
                  <span>{formatTime(currentTime)}</span>

                  <span>{formatTime(duration)}</span>
                </TimerSection> */}
        </PlayerButtons>
        {/* <Spacer height={5} /> */}
        <>
          <TimerSection style={{ fontSize: 12, marginTop: '-10px' }}>
            <span>{formatTime(currentTime)}</span>

            <span>{formatTime(duration)}</span>
          </TimerSection>
          <Spacer height={10} />
          <MusicProgression ref={progressRef} onClick={handleProgressClick}>
            <div style={{ width: `${(currentTime / duration) * 100}%` }}>
              <div className="player-circle"></div>
            </div>
          </MusicProgression>
        </>
      </div>
    </MusicPlayerButtons>
  )
}

export default MPButtons
